// FCM push notification icin cihaz kayit DTO'lari.
// Mobile uygulama acildikca getDevicePushTokenAsync ile aldigi token'i buraya gonderir.
import { z } from 'zod';
export const cihazPlatformu = z.enum(['IOS', 'ANDROID', 'WEB']);
export const bildirimCihazKayitIstegi = z.object({
    fcmToken: z.string().min(20).max(500),
    platform: cihazPlatformu,
    cihazAdi: z.string().max(120).optional(),
    uygulamaSurum: z.string().max(40).optional(),
});
//# sourceMappingURL=cihaz-kayit.js.map